import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
import PatientList from '../../components/telemedicina/PatientList';
import VideoCallButton from '../../components/telemedicina/VideoCallButton';
import ChatBox from '../../components/telemedicina/ChatBox';
import NotesSection from '../../components/telemedicina/NotesSection';
import PrescriptionForm from '../../components/telemedicina/PrescriptionForm';
import './TelemedicinaPage.css';

const TelemedicinaPage = () => {
  const [patients, setPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [messages, setMessages] = useState([]);
  const [notes, setNotes] = useState('');
  const [prescription, setPrescription] = useState('');
  const auth = getAuth();
  const db = getFirestore();
  const user = auth.currentUser;

  useEffect(() => {
    const fetchPatients = async () => {
      if (user) {
        try {
          const q = query(
            collection(db, 'agenda'),
            where('userId', '==', user.uid),
            where('tipo', '==', 'Teleconsulta')
          );
          const querySnapshot = await getDocs(q);
          const fetchedPatients = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            name: doc.data().nomePaciente,
            email: doc.data().emailPaciente,
            telefone: doc.data().telefonePaciente,
            dataHora: doc.data().dataHora,
          }));
          setPatients(fetchedPatients);
        } catch (e) {
          console.error('Erro ao buscar pacientes agendados: ', e);
        }
      }
    };

    fetchPatients();
  }, [user, db]);

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient);
  };

  const handleSendMessage = (message) => {
    setMessages((prevMessages) => [...prevMessages, message]);
  };

  const handleSaveNotes = (newNotes) => {
    setNotes(newNotes);
  };

  const handleSendPrescription = (newPrescription) => {
    setPrescription(newPrescription);
  };

  return (
    <Layout>
      <div className="telemedicina-container">
        <h2>Teleatendimento</h2>

        <PatientList
          patients={patients}
          onSelectPatient={handleSelectPatient}
        />
        {selectedPatient && <VideoCallButton patient={selectedPatient} />}
        <ChatBox messages={messages} onSendMessage={handleSendMessage} />
        <NotesSection notes={notes} onSaveNotes={handleSaveNotes} />
        <PrescriptionForm
          prescription={prescription}
          onSendPrescription={handleSendPrescription}
        />
      </div>
    </Layout>
  );
};

export default TelemedicinaPage;
